import React from 'react';

import {
    Logout,
    BusinessOutlined,
    GroupsOutlined,
    PeopleOutline,
    NotificationsOutlined,
    LocalShippingOutlined,
    LocalOfferOutlined,
    MailOutline,
    FeedbackOutlined,
    InsightsOutlined,
    AdminPanelSettingsOutlined,
    TouchAppOutlined,
    ChatOutlined,
    MapOutlined,
    LanguageOutlined,
    EditNoteOutlined,
    ManageSearchOutlined,
    // ArticleOutlined,
    NewspaperOutlined
} from '@mui/icons-material';

import logout from '../../utils/logout';

type LinkType = {
    name: string,
    icon: JSX.Element,
    path?: string,
    action?: () => void,
    key?: string,
    links?: LinkType[],
    isAdmin?: boolean
};

export default function getMenuLinks({ canReadStats }: { canReadStats: boolean }): LinkType[] {
    const menuLinks = [{
        name: 'Karta',
        icon: <MapOutlined />,
        path: '/map'
    },
    {
        name: 'Företag',
        icon: <BusinessOutlined />,
        path: '/tenants'
    },
    {
        name: 'Skrapad Data',
        icon: <ManageSearchOutlined />,
        path: '/scraped-companies'
    },
    {
        name: 'Nya uppgifter',
        icon: <EditNoteOutlined />,
        path: '/tenant-updates'
    },
    {
        name: 'Användare',
        icon: <PeopleOutline />,
        path: '/users'
    }, {
        name: 'Grupper',
        icon: <GroupsOutlined />,
        path: '/groups'
    }, {
        name: 'Bevakningar',
        icon: <NotificationsOutlined />,
        path: '/watchlists'
    }, {
        name: 'Uppdrag',
        icon: <LocalShippingOutlined />,
        path: '/orders'
    }, {
        name: 'Anbud',
        icon: <LocalOfferOutlined />,
        path: '/offers'
    }, {
        name: 'Meddelanden',
        icon: <ChatOutlined />,
        path: '/offer-messages'
    }, {
        name: 'Från hemsida',
        icon: <LanguageOutlined />,
        path: '/order-registrations'
    }, {
        name: 'Artiklar',
        icon: <NewspaperOutlined />,
        path: '/articles'
    }, {
        name: 'Inbjudningar',
        icon: <MailOutline />,
        path: '/invites'
    }, {
        name: 'Feedback',
        icon: <FeedbackOutlined />,
        path: '/feedback'
    }, {
        name: 'Aktiviteter',
        icon: <TouchAppOutlined />,
        path: '/requests'
    }, {
        name: 'Statistik',
        icon: <InsightsOutlined />,
        key: 'admin',
        path: '/stats',
        canReadStats: true
    }, {
        name: 'Administratörer',
        icon: <AdminPanelSettingsOutlined />,
        path: '/admins'
    }, {
        name: 'Logga ut',
        icon: <Logout />,
        action: logout
    }];

    return canReadStats ? menuLinks : menuLinks.filter((l) => !l.canReadStats);
}
